import { StateSelect } from '@/components/legislative-tracker/LegislativeTracker/components/StateSelect'
import { RenderLink } from '@/heros/HeroCenter'

import type { CallToActionBlockProps } from '../Component'

export const LinksBlock: React.FC<{
  links: CallToActionBlockProps['links']
  showStateSelect?: CallToActionBlockProps['showStateSelect']
  stateSelectProps?: CallToActionBlockProps['stateSelectProps']
}> = ({ links, showStateSelect, stateSelectProps }) => {
  const { handleStateChange, stateSelectMobileRef, stateSelectDesktopRef, selectedState } =
    stateSelectProps || {}
  return (
    <div className="flex flex-row gap-4 [&_button]:w-auto [&_button]:min-w-50">
      {links &&
        links.length > 0 &&
        !showStateSelect &&
        links.map(({ link }, i) => (
          <RenderLink
            key={i}
            link={link}
            color={i % 2 === 0 ? 'primary' : 'outlinePrimary'}
            icon={i % 2 === 0 ? true : false}
          />
        ))}
      {showStateSelect && (
        <StateSelect
          stateSelectMobileRef={stateSelectMobileRef ?? undefined}
          stateSelectDesktopRef={stateSelectDesktopRef ?? undefined}
          selectedState={selectedState ?? undefined}
          handleStateChange={handleStateChange ?? ((_state: string | undefined) => {})}
        />
      )}
    </div>
  )
}
